import React from 'react';
import _get from 'lodash/get';
import { Parallax } from 'react-parallax';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useSiteCopySelector from 'components/useSiteCopySelector';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  section: {
    paddingTop: 100,
    paddingBottom: 100,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 30,
      paddingBottom: 30,
    },
  },
  wrapper: {
    width: '80%',
    maxWidth: 1080,
    margin: 'auto',
  },
  textBlock: {
    marginBottom: '5.82%',
  },
  label: {
    fontFamily: 'PoppinsMedium',
    fontSize: 23,
    lineHeight: '1.2em',
    color: '#333333',
    paddingBottom: 10,
    width: '57.8%',
    fontWeight: '500',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  h1: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: 45,
    fontWeight: '600',
    color: '#333333',
    lineHeight: '1.2em',
    paddingBottom: 10,
    width: '57.8%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  h2: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: 30,
    fontWeight: '600',
    color: '#333333',
    lineHeight: '46px',
    paddingBottom: 10,
    width: '57.8%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  ul: {
    paddingLeft: '1em',
    lineHeight: 26,
    listStyleType: 'disc',
    margin: 0,
  },
  li: {
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '29px',
    color: '#000000',
    paddingBottom: 10,
    '&::marker': {
      color: '#666666',
    },
  },
}));

function Hero() {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  const [solutionsSiteCopy] = useSiteCopySelector(['solutions-homepage']);
  const config = _get(solutionsSiteCopy, 'pageCopy.hero', {});
  const classes = useStyles();

  return (
    <section id="hero">
      <Parallax
        bgImage={isSmDown ? config.mobileImage : config.image}
        style={{ paddingTop: isSmDown ? 0 : 36 }}
        strength={200}
      >
        <div className={classes.section}>
          <div className={classes.wrapper}>
            <div className={classes.textBlock}>
              {config.label && (
                <Typography className={classes.label}>
                  {config.label}
                </Typography>
              )}
              <Typography className={classes.h1}>{config.title}</Typography>
              {config.subtitle && (
                <Typography className={classes.h2}>
                  {config.subtitle}
                </Typography>
              )}
              {config.bullet && (
                <ul className={classes.ul}>
                  {config.bullet.map(bullet => (
                    <li className={classes.li}>{bullet}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </Parallax>
    </section>
  );
}

export default Hero;
